const SHIPPING_SUMMARY = {
  negotiatedShippingTotal: {
    label: 'Frete Negociado',
    tooltipText: 'Valor base combinado em contrato, sem incluir adicionais.',
  },
  freightIncentive: {
    label: 'Incentivo de Frete',
    tooltipText:
      'Valor reembolsado em incentivos extras de entrega, como entregas na madrugada.',
  },
  routeGroupingDiscount: {
    label: 'Desconto de Agrupamento',
    tooltipText: 'Aplicado quando há 3 ou mais entregas na mesma rota.',
  },
  heavyOrderAdditional: {
    label: 'Adicional Pedido Grande',
    tooltipText:
      'Cobrado de clientes em pedidos com volume ou peso acima do padrão.',
  },
  turboAdditional: {
    label: 'Adicional Turbo',
    tooltipText: 'Valor repassado da cobrança de entrega turbo.',
  },
  distanceAdditionalFee: {
    label: 'Adicional de Longa Distância',
    tooltipText:
      'Valor adicional repassado pelas entregas realizadas acima da quilometragem padrão do contrato.',
  },
  paidByConsumer: {
    label: 'Pago pelo Cliente',
    tooltipText:
      'Valor pago pelo cliente direto na maquininha e dinheiro na entrega ou repassado via pagamento online.',
  },
  downloadButtonTextSuffix: 'frete por pedido',
  errorMessage:
    'Houve um erro ao carregar o resumo de fretes. Tente novamente mais tarde.',
  errorMessageShippingTotalMismatch:
    'Restitution details shipping total mismatch',
}

export default SHIPPING_SUMMARY
